<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.class}`"
    :data-type="context.type"
  >
    <fishbone-diagram v-bind="finalFishboneData"></fishbone-diagram>
  </div>
</template>

<script>
  // currently MUST have echarts on the page using script tag
  // fishbone-diagram component is a global async import (as of Dec 16 2022)
  // put all props for the FishboneDiagram component into 'fishboneData' prop here (one object)

  export default {
    name: 'FormulateFishboneDiagram',
    components: {},
    mixins: [],
    props: {
      context: {
        // the required Formulate context prop
        type: Object,
        required: true,
      },
      fishboneData: {
        // you CAN pass things in here... OR context.model -- if its easier to pass in as the 'value' of the input
        type: Object,
        required: false,
      },
    },
    data: function () {
      return {};
    },
    computed: {
      finalFishboneData() {
        return this.fishboneData ?? this.context.model ?? {};
      },
    },
    mounted: function () {},
    methods: {
      // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
    },
  };
</script>

<style lang="scss" scoped></style>
